jQuery("#back-top").hide();
jQuery(function () {
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 1000) {
            jQuery('#back-top').fadeIn();
            jQuery("#back-top").addClass('active');
        } else {
            jQuery('#back-top').fadeOut();
            jQuery("#back-top").removeClass('active');
        }
    });
    jQuery('#back-top').click(function () {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 1000);
        return false;
    });
});

document.querySelectorAll('a[href="#contact-form"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});
window.onscroll = function () { //myFunction() 
};
var header = document.getElementById("header");
if (header != null) {
    var sticky = header.offsetTop;
}
function myFunction() {
    if (window.pageYOffset > sticky) {
        header.classList.add("fixed");

    } else {
        header.classList.remove("fixed");
    }
}
/**********************footer menu ********************** */

jQuery(document).on("click", ".collapse-menu h4", function (e) {
    jQuery(this).parents(".collapse-menu").find(".menu-collapse-wrap").slideToggle("slow");
    jQuery(this).parents(".collapse-menu").toggleClass("menushow");
});


function lazyloader() {
    const lazyContent = new LazyLoad({
        elements_selector: ".lazy"
    });

    const lazyBackground = new LazyLoad({
        elements_selector: "iframe.lazy, video.lazy, div.lazy, section.lazy, button.lazy,header.lazy"
    });
}


$(document).ready(function () {
    lazyloader();
    $('.datetimepicker').datetimepicker();

    $('#toggleMenu').on('click', function () {
        $('.primary-menu-wrapper').toggleClass('openmenu');
    });

    $('.menuCloseIcon').on('click', function () {
        $('.primary-menu-wrapper').removeClass('openmenu');
    });

    /**********************Tab And Accordian********************** */

    // Loop through each tab container to set up independent tabs
    $('.tab-container').each(function () {
        const $container = $(this);
        const $tabButtons = $container.find('.tab-button');
        const $tabContentItems = $container.find('.tab-content-item');

        // Set up click event for each button within this container
        $tabButtons.on('click', function () {
            const $button = $(this);
            console.log($button);
            const target = $button.data('tab');
            console.log(target);

            // Remove active class from all buttons and add to clicked button
            $tabButtons.removeClass('active');
            $button.addClass('active');

            if (target != "all") {
                // Add fade effect to content items
                $tabContentItems.filter(':visible').fadeOut(200, function () {
                    $tabContentItems.addClass('hidden');
                    $tabContentItems.filter(`[data-content="${target}"]`).removeClass('hidden').fadeIn(200);
                });
            } else {
                $tabContentItems.removeClass('hidden').fadeIn(200);
            }
        });
    });
    $('.accordion-group').each(function () {
        const $accordionGroup = $(this);
        // Toggle functionality for each accordion item
        $accordionGroup.find('.accordion-toggle').click(function () {
            // Close other items in the current group and reset icons to "+"
            $accordionGroup.find('.accordion-content').not($(this).next()).slideUp();
            $accordionGroup.find('.accordion-item').removeClass('accordion-active');
            $accordionGroup.find('.accordion-icon').not($(this).find('.accordion-icon')).removeClass('rotate-180');
            $(this).parents('.accordion-item').addClass('accordion-active');

            // Toggle current item and icon
            $(this).next().slideToggle();
            const icon = $(this).find('.accordion-icon');
            icon.toggleClass('rotate-180');
        });
    });

    $(document).on('click', '.menu-collapse-container .collapse-menu-title', function () {
        $(this).parents('.menu-collapse-container').find('.menu-collapse-wrap').slideToggle();
        $(this).find('svg').toggleClass('rotate-180');
    });


    $('.products-slider').each(function (index) {
        const nextArrow = $(this).parents('.products-slider-container').find('.products-next');
        $(this).slick({
            slidesToShow: 2,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 500,
            cssEase: 'linear',
            infinite: true,
            focusOnSelect: false,
            dots: false,
            variableWidth: true,
            nextArrow: nextArrow,
            prevArrow: false,// optional if you don’t use previous arrow
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    });

    $('.reviews-slider').slick({
        slidesToShow: 3,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        cssEase: 'linear',
        infinite: true,
        centerMode: true,
        centerPadding: '60px',
        focusOnSelect: false,
        dots: false,
        variableWidth: true,
    });

    $('.services-slider').slick({
        slidesToShow: 4,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        cssEase: 'linear',
        infinite: true,
        nextArrow: $('.services-next'),
        prevArrow: $('.services-prev'),
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            },
        ]
    });

    $('.commercial-services-slider').slick({
        slidesToShow: 4,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        cssEase: 'linear',
        infinite: true,
        variableWidth: true,
        nextArrow: $('.commercial-services-next'),
        prevArrow: $('.commercial-services-prev'),
    });


    $('.services-list-slider').each(function (index) {
        const nextArrow = $(this).parents('.services-list-slider-container').find('.services-list-next');
        const prevArrow = $(this).parents('.services-list-slider-container').find('.services-list-prev');
        $(this).slick({
            slidesToShow: 3,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 500,
            cssEase: 'linear',
            infinite: true,
            focusOnSelect: false,
            variableWidth: true,
            dots: false,
            nextArrow: nextArrow,
            prevArrow: prevArrow,
            lazyLoad: 'ondemand',

        });
    });

    if (window.innerWidth < 992) {
        $('.mobile-slider').slick({
            slidesToShow: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 500,
            cssEase: 'linear',
            variableWidth: true,
        });
    }

    $('.youtube-slider').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 2500,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });
    /* Step Form */
    // Show a specific step by number
    function showStep(stepNumber) {
        $(".form-step").removeClass("active").addClass("hidden");
        $(`.form-step[data-step="${stepNumber}"]`).addClass("active").removeClass("hidden");
    }

    // Validate all fields in the current step
    function validateStep(stepNumber) {
        let isValid = true;
        const $step = $(`.form-step[data-step="${stepNumber}"]`);
        const inputs = $step.find("input, select, textarea");
        $step.find(".error-msg").remove();

        inputs.each(function () {
            const $field = $(this);
            const val = $.trim($field.val());

            // Required validation
            if ($field.prop("required") || $field.hasClass("wpcf7-validates-as-required")) {
                if (!val) {
                    isValid = false;
                    $field.after('<span class="error-msg">This field is required</span>');
                }
            }

            // Email format check
            if ($field.attr("type") === "email" && val) {
                const emailRegex = /^[^@]+@[^@]+\.[a-z]{2,}$/i;
                if (!emailRegex.test(val)) {
                    isValid = false;
                    $field.after('<span class="error-msg">Enter a valid email</span>');
                }
            }

            // Phone format check
            if ($field.attr("type") === "tel" && val) {
                const phoneRegex = /^[0-9\-\+\s\(\)]+$/;
                if (!phoneRegex.test(val)) {
                    isValid = false;
                    $field.after('<span class="error-msg">Enter a valid phone</span>');
                }
            }
        });

        return isValid;
    }
    $('input[name="date-time"]').attr('autocomplete', 'off');
    // Next button click
    $(".next-step").on("click", function () {
        const nextStep = $(this).data("next");
        const currentStep = nextStep - 1;

        if (validateStep(currentStep)) {
            showStep(nextStep);
        }
    });

    // Show step 1 by default
    showStep(1);
    /* End Step Form */


    $('.close-cta').click(function () {
        $(this).parents('.fixed-cta').fadeOut();
    });


    $('.services-control-section  a[href^="#"]').on('click', function (e) {
        var target = $(this.getAttribute('href'));

        if (target.length) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: target.offset().top - 50 // adjust offset for sticky header if needed
            }, 700); // speed
        }
    });

    // Append a "no results" message container if it doesn't exist
    if ($('.areas-list-section .no-results').length === 0) {
        $('.areas-list-section').append('<div class="no-results text-center mt-5 text-lg font-medium hidden">No matching suburbs found.</div>');
    }

    function filterAreas() {
        var searchTerm = $('.map .form-input').val().toLowerCase();
        var anyVisible = false;

        $('.areas-list-section .area-items').each(function () {
            var areaName = $(this).find('a').text();

            if (areaName.toLowerCase().indexOf(searchTerm) !== -1) {
                $(this).show();
                anyVisible = true;
            } else {
                $(this).hide();
            }
        });

        // Show or hide "No results" message
        if (!anyVisible) {
            $('.areas-list-section .no-results').removeClass('hidden');
        } else {
            $('.areas-list-section .no-results').addClass('hidden');
        }

        return anyVisible;
    }

    $('.map button[type="submit"]').on('click', function (e) {
        e.preventDefault();

        var found = filterAreas();

        // Scroll to the areas list section after search
        $('html, body').animate({
            scrollTop: $('.areas-list-section').offset().top - 20 // adjust offset if needed
        }, 600);
    });

    // Optional: also filter on typing
    $('.map .form-input').on('keyup', filterAreas);



    // Open Popup
    $(".open-book-popup").on("click", function (e) {
        e.preventDefault();
        $("#custom-popup").removeClass("hidden");
    });

    $(".open-productform-popup").on("click", function (e) {
        e.preventDefault();
        $html = $(this).parents('.product-block-wrapper').find('.product-block').html();
        $price = $(this).parents('.product-block-wrapper').find('.product-price-value').text();
        $name = $(this).parents('.product-block-wrapper').find('.product-block-title').text();
        $(".product-input-wrapper").removeClass("hidden");
        $("#custom-popup input[name='product-price']").val($price);
        $("#custom-popup input[name='product-name']").val($name);
        $("#custom-popup .product-input").html($html);
        $("#custom-popup").removeClass("hidden");
    });

    // Close Popup
    $("#popup-close-btn").on("click", function (e) {
        $("#custom-popup").addClass("hidden");
    });

    var $popup = $("#video-popup");
    var $iframe = $("#video-frame");

    $(".open-video-popup").on("click", function () {
        var url = $(this).data("video-url");
        if (url.includes("youtube") || url.includes("vimeo")) {
            url += (url.includes("?") ? "&" : "?") + "autoplay=1&mute=1";
        }
        console.log(url);
        $iframe.attr("src", url);
        $popup.removeClass("hidden").addClass("flex");
    });

    $("#close-video").on("click", function () {
        $popup.addClass("hidden").removeClass("flex");
        $iframe.attr("src", ""); // stop video
    });

    // close when clicking outside video
    $popup.on("click", function (e) {
        if ($(e.target).is($popup)) {
            $("#close-video").click();
        }
    });

    var $slider = $('.banner-v3-deal-slider');
    if ($slider.length && $.fn.slick) {
        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            arrows: false,
            dots: true,
            fade: true,
            cssEase: 'linear',
            adaptiveHeight: false
        });
    }
});